import React, { Component, Suspense } from 'react';
import Body from 'components/layout/Body';
import RouteConfig from 'router/Router';
import Loading from 'components/shared/Loading';
import { BrowserRouter as Router } from "react-router-dom";
import { connect } from 'react-redux';
import Message from 'components/message/Message';
import { Container } from 'react-bootstrap';
import Header from 'components/layout/Header';
import { actionLogout } from 'redux/actions/UserActions';
import { actionCleanLoading } from 'redux/actions/SharedActions';
import { getLanguageLocalStorage } from 'redux/services/StorageServices';
import { actionChangeLanguage } from 'redux/actions/TranslatorActions';
import { LANGUAGES } from 'constants/Languages';
import Translate from 'components/translate/Translate';

class Layout extends Component {

  componentDidMount = (oProps) => {
    window.onbeforeunload = (e) => {
      this.props.clean();
    };
    // Inicializacion del idioma en local storage y reducer
    getLanguageLocalStorage().then(oSuccess => {
      this.props.setLanguage(oSuccess ?? LANGUAGES.SPANISH);
    })
  }

  logout = () => {
    this.props.logout();
  }

  render = () => {
    const { oUser } = this.props.oSession;
    return (
      <div>
        <Router>
          <Header fLogout={this.logout} oUser={oUser} />
          <Body>
            <Container className='my-5'>
              <Suspense fallback={<div><Translate label='LOADING' /></div>}>
                <RouteConfig />
              </Suspense>
            </Container>
          </Body>
        </Router>
        <Loading />
        <Message />
      </div>
    );
  }
}

const mapStateToProps = oState => ({
  oSession: oState.SessionReducer
});

const mapDispatchToProps = dispatch => ({
  logout: () => {
    dispatch(actionLogout());
  },
  clean: () => {
    dispatch(actionCleanLoading());
  },
  setLanguage: (sLanguage) => {
    dispatch(actionChangeLanguage(sLanguage));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);